import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './index.sass';
import Bubble from '../../../Atoms/Bubble';
import AttachmentModal from '../../../Sirius/AttachmentModal';

const MessageImage = ({ messageInfo, children }) => {
	const [attachmentIsOpen, setAttachmentIsOpen] = useState(false);

	return (
		<>
			<Bubble timeOnBottom className="MessageImage" messageInfo={messageInfo}>
				{children}
				<div
					className="ExpandFile is-flex is-align-items-center is-justify-content-center has-background-white is-clickable"
					onClick={() => setAttachmentIsOpen(true)}
					role="button"
					tabIndex={0}
				>
					<span className="icon is-medium has-text-dark">
						<i className="fa-light fa-image-polaroid" />
					</span>
				</div>
				<img src={messageInfo.url} alt="Media: " />
				{messageInfo.content}
			</Bubble>
			{
				attachmentIsOpen && (
					<AttachmentModal
						url={messageInfo.url}
						mimeType={messageInfo.contentType}
						messageId={messageInfo.messageId}
						onClose={() => setAttachmentIsOpen(false)}
					/>
				)
			}
		</>
	);
};

MessageImage.propTypes = {
	messageInfo: PropTypes.shape({
		isFromAgent: PropTypes.bool,
		content: PropTypes.string,
		createdAt: PropTypes.string,
		status: PropTypes.string,
		url: PropTypes.string,
		agentName: PropTypes.string,
		agentPhoto: PropTypes.string,
		interactionType: PropTypes.string,
		contentType: PropTypes.string,
		messageId: PropTypes.number
	}).isRequired
};

export default MessageImage;
